
import React from 'react';
import { usePrayerChoiceDialog } from '@/hooks/usePrayerChoiceDialog';
import PrayerChoiceController from '@/components/ai-prayer/choice/PrayerChoiceController';
import ActionButtonsVerticalContainer from './ActionButtonsVerticalContainer';
import { ActionButtonsVerticalProps } from './ActionButtonsVerticalProps';

export default function GeneratedPrayerActionButtonsVertical(props: ActionButtonsVerticalProps) {
  const { 
    isOpen, 
    isMinimized, 
    prayerContext, 
    isAiAssistantOpen,
    openChoiceDialog, 
    closeChoiceDialog, 
    minimizeChoiceDialog,
    restoreChoiceDialog,
    handleINeedPrayer, 
    handleIWantToPray,
    closeAiAssistant
  } = usePrayerChoiceDialog();

  // Handle pray action with choice dialog and source context
  const handlePrayAction = () => {
    openChoiceDialog({
      id: props.prayer.id,
      title: props.prayer.title,
      content: props.prayer.content
    }, props.positioning === 'fixed' ? 'prayer_card' : 'prayer_detail');
  };

  return (
    <>
      <ActionButtonsVerticalContainer
        {...props}
        onPray={handlePrayAction}
      />

      {/* Prayer Choice Controller */}
      <PrayerChoiceController
        isOpen={isOpen}
        onClose={closeChoiceDialog}
        onINeedPrayer={handleINeedPrayer}
        onIWantToPray={handleIWantToPray}
        prayerContext={prayerContext}
        isAiAssistantOpen={isAiAssistantOpen}
        onCloseAiAssistant={closeAiAssistant}
      />
    </>
  );
}
